import React, { useEffect, useState } from "react";
import { MailWarning } from "lucide-react";
import { parApi } from "@/lib/partnerApi";
import { reApi } from "@/lib/residentApi";
import { useFloatingWindows } from "@/lib/floatingWindows";
import { MEMOS_CHANGED } from "@/components/nds/windows/partner/memos/PartnerMemosContent";

/** Red bar across the top while the signed-in user has unread memos directed to them (partner memos + resident memos to/from them). */
export default function UnreadMemoBanner() {
  const [c, setC] = useState({ par: 0, res: 0, residents: [] });
  const { openWindow } = useFloatingWindows();
  useEffect(() => {
    const load = () => Promise.all([parApi.get("/memos/unread-count").catch(() => ({ unread: 0 })), reApi.get("/memos/unread-count").catch(() => ({ unread: 0, residents: [] }))])
      .then(([p, r]) => setC({ par: p.unread || 0, res: r.unread || 0, residents: r.residents || [] }));
    load();
    const t = setInterval(load, 45000);
    window.addEventListener(MEMOS_CHANGED, load);
    window.addEventListener("focus", load);
    return () => { clearInterval(t); window.removeEventListener(MEMOS_CHANGED, load); window.removeEventListener("focus", load); };
  }, []);
  const total = c.par + c.res;
  if (!total) return null;
  const link = "underline underline-offset-2 decoration-white/50 hover:decoration-white font-semibold";
  return (
    <div data-testid="unread-memo-banner" role="alert" className="sticky top-0 z-[60] w-full bg-red-700 text-white text-sm">
      <div className="max-w-[1920px] mx-auto px-6 lg:px-10 py-2 flex flex-wrap items-center gap-x-4 gap-y-1">
        <span className="inline-flex items-center gap-2 font-semibold"><MailWarning className="h-4 w-4" /> <span data-testid="unread-memo-banner-count">{total}</span> unread memo{total === 1 ? "" : "s"}</span>
        {c.par > 0 && <button type="button" onClick={() => openWindow("par_memos", { title: "Partner Memos" })} data-testid="unread-memo-banner-partner" className={link}>{c.par} partner</button>}
        {c.residents.map((x) => (
          <button key={x.resident_id} type="button" onClick={() => openWindow("re_memos", { title: `Memos · ${x.name}`, residentId: x.resident_id })} data-testid={`unread-memo-banner-res-${x.resident_id}`} className={link}>
            {x.name} ({x.count})</button>))}
      </div>
    </div>
  );
}
